/**
 * Return true when the admin is Super Admin.
 *
 * This app has a few legacy shapes for "role":
 * - persisted session (`_bna`) uses `role`
 * - some APIs/components use `roleId`
 * - permissions state uses `isSuperAdmin` from GET /admin/me/permissions
 */
export function isSuperAdminUser(user, permState) {
  // Prefer the permissions flag when present.
  if (permState?.isSuperAdmin === true) return true;
  if (permState?.isSuperAdmin === false) return false;

  const rawRole =
    user?.roleId ??
    user?.role ??
    user?.role_id ??
    user?.roleID ??
    user?.RoleId ??
    null;

  if (rawRole == null) return false;
  const n = Number(rawRole);
  return n === 1;
}

